import * as React from 'react';

import PaymentDetailsForm from '../../../payment/PaymentDetailsForm';
import { Checkbox, CountryDropdown, ProvinceDropdown, TextInput, ToggleSwitch } from '../../../components/forms';
import Utils, { InputError } from '../../../common/utils';

interface Props {
	actions: any;
	paymentDetails: any;
	user: UserDetails;
	customerPolicy: CustomerPolicy;
	onUserChange: (e: any) => void;
	onPolicyChange: (e: any) => void;
	onStripeElementChange?: (element: any, name: any) => void;
	onPhoneKeyUp: (e: any) => void;
	errors: { mailingPostalCode: InputError, billingPostalCode: InputError };
	isCustomer: boolean;
}
interface State {
	touched: {
		mailingPostalCode: boolean;
		billingPostalCode: boolean;
	};
}
class BillingForm extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = {
			touched: {
				mailingPostalCode: false,
				billingPostalCode: false
			}
		};
	}

	handleBlur = (field: any) => (evt: any) => {
		this.setState({
			touched: { ...this.state.touched, [field]: true }
		});
	}

	render() {
		const userText = this.props.isCustomer ? 'your' : 'customer\'s';
		const sameAddressLabelText = this.props.isCustomer ? 'Your billing address is the same as your mailing address' :
		'Customer\'s billing address is the same as the mailing address';
		const recieveCopyLabelText = this.props.isCustomer ? 'After you enroll, your policy will be emailed to you and will ' +
		'also be available through your online account. In addition to this, would you also like to receive a paper copy ' +
		'in the mail?' :
		'Would customer like to receive a paper copy in the mail?';
		return (
			<fieldset>
				<div className="row">
					<p className="col-12">Please enter {userText} payment details.</p>
					<div className="col-12">
						<PaymentDetailsForm
							details={this.props.paymentDetails}
							actions={this.props.actions}
							onStripeElementChange={this.props.onStripeElementChange}
						/>
					</div>
				</div>
				<div className="row mt-4">
					<p className="col-12">Please enter {userText} mailing address.</p>
					<TextInput
						labelText="Street address"
						name="mailingAddress"
						onChange={this.props.onUserChange}
						value={this.props.user.mailingAddress}
						className="col-12"
					/>
					<TextInput
						labelText="City"
						name="mailingCity"
						onChange={this.props.onUserChange}
						value={this.props.user.mailingCity}
						className="col-sm-6"
					/>
					<ProvinceDropdown
						labelText="Province"
						name="mailingProvince"
						province={this.props.user.mailingProvince}
						onChange={this.props.onUserChange}
						className="col-sm-6"
					/>
					<TextInput
						labelText="Postal code"
						name="mailingPostalCode"
						onBlur={this.handleBlur('mailingPostalCode')}
						onChange={this.props.onUserChange}
						value={this.props.user.mailingPostalCode}
						className="col-sm-6"
						error={
							Utils.shouldMarkError(this.props.errors.mailingPostalCode, this.state.touched.mailingPostalCode)
								? this.props.errors.mailingPostalCode
								: undefined
						}
					/>
					<CountryDropdown
						labelText="Country"
						name="mailingCountry"
						country={this.props.user.mailingCountry}
						onChange={this.props.onUserChange}
						className="col-sm-6"
					/>
				</div>
				<Checkbox
					label={sameAddressLabelText}
					name="isSameAddress"
					onChange={this.props.onUserChange}
					checked={this.props.user.isSameAddress}
				/>
				{!this.props.user.isSameAddress && (
					<div className="row mt-4">
						<p className="col-12">Please enter {userText} billing address</p>
						<TextInput
							labelText="Address"
							name="billingAddress"
							onChange={this.props.onUserChange}
							value={this.props.user.billingAddress}
							className="col-sm-12"
						/>
						<TextInput
							labelText="City"
							name="billingCity"
							onChange={this.props.onUserChange}
							value={this.props.user.billingCity}
							className="col-sm-6"
						/>
						<ProvinceDropdown
							labelText="Province"
							name="billingProvince"
							province={this.props.user.billingProvince}
							onChange={this.props.onUserChange}
							className="col-sm-6"
						/>
						<TextInput
							labelText="Postal code"
							name="billingPostalCode"
							onBlur={this.handleBlur('billingPostalCode')}
							onChange={this.props.onUserChange}
							value={this.props.user.billingPostalCode}
							className="col-sm-6"
							error={
								Utils.shouldMarkError(this.props.errors.billingPostalCode, this.state.touched.billingPostalCode)
									? this.props.errors.billingPostalCode
									: undefined
							}
						/>
						<CountryDropdown
							labelText="Country"
							name="billingCountry"
							country={this.props.user.billingCountry}
							onChange={this.props.onUserChange}
							className="col-sm-6"
						/>
					</div>
				)}
				<div className="row mt-4">
					<p className="col-12">Please enter {userText} phone number and e-mail address.</p>
					<TextInput
						labelText="Phone"
						name="phoneNumber"
						onChange={this.props.onUserChange}
						onKeyUp={this.props.onPhoneKeyUp}
						value={this.props.user.phoneNumber}
						className="col-md-6 mb-0"
					/>
					<TextInput
						labelText="E-mail"
						name="email"
						onChange={this.props.onUserChange}
						value={this.props.user.email}
						className="col-md-6 mb-0"
					/>
				</div>
				<div className="row mt-4">
					<ToggleSwitch
						id="receivePaperCopy"
						labelText={recieveCopyLabelText}
						name="receivePaperCopy"
						onChildren="Yes"
						offChildren="No"
						onChange={this.props.onPolicyChange}
						checked={this.props.customerPolicy.receivePaperCopy}
						className="col-12 toggle-yes-no"
					/>
				</div>
			</fieldset>
		);
	}
}
export default BillingForm;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/quoting/enrollment/billing-review/BillingForm.tsx